
  import * as ipxRuntime$i0FHbV0I8idLcWnTtxAXtOth8x9hlpv_45anN7tNunMO0 from '/workspace/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$i0FHbV0I8idLcWnTtxAXtOth8x9hlpv_45anN7tNunMO0, defaults: {} }
    }
  }
